import executor from "./api";

const api = executor.getPrefixedMethods("/notes");

export const userNotesService = {
  // Get all notes
  getAllNotes: () => {
    return api.get("");
  },

  // Create a new note
  createNote: (noteData) => {
    return api.post("", noteData);
  },

  // Get a specific note by ID
  getNote: (noteId) => {
    return api.get(`${noteId}/`);
  },

  // Update a note
  updateNote: (noteId, noteData) => {
    return api.put(`${noteId}/`, noteData);
  },
};
